import { call, put, takeLatest } from "redux-saga/effects";
import { getFeatureSet } from "../../services/config";
import { configActions, FeatureSet } from "./configSlice";

const parseFeatureSet = (raw: unknown): FeatureSet | null => {
  if (!raw) return null;

  let parsed: any = raw;
  if (typeof raw === "string") {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return null;
    }
  }

  // Interceptor returns decrypted `data`; some responses may nest under `.data`
  if (parsed?.data && typeof parsed.data === "object" && !Array.isArray(parsed.data)) {
    return parsed.data as FeatureSet;
  }

  return parsed as FeatureSet;
};

function* fetchFeatureSet(): any {
  try {
    const result = yield call(getFeatureSet);
    const parsed = parseFeatureSet(result?.data);

    if (!parsed) {
      yield put(configActions.fetchFeatureSetFailed("Invalid feature-set response"));
      return;
    }

    yield put(configActions.fetchFeatureSetSucceeded(parsed));
  } catch (e: any) {
    yield put(
      configActions.fetchFeatureSetFailed(
        e?.response?.data?.error?.type ||
          e?.response?.error ||
          e?.message ||
          "Failed to load feature set"
      )
    );
  }
}

export default function* configSaga() {
  yield takeLatest(configActions.fetchFeatureSetRequested.type, fetchFeatureSet);
}
